import has from 'lodash/has'

export default accountStatus

/** @ngInject */
function accountStatus($compile, $uibModal, PermPermissionStore, ContractStatusLabel, ContactTelephone) {
    return ({
        restrict: 'E',
        scope: {
            userContract: '=',
            isRetractable: '=',
        },
        template: require('./accountStatus.jade')(),
        link($scope) {
            $scope.isUnknownStatus = false
            $scope.contactTelephone = ContactTelephone
            const activate = () => {
                $scope.isUnknownStatus = !has(ContractStatusLabel, $scope.userContract.status)
            }

            $scope.openContactModal = () =>
        $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: require('../../contactModal/contactModal.jade')(),
            resolve: {
                contractSelected() {
                    return $scope.contractSelected
                },
                userInfo(ApiService) {
                    return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                    .then(() => ApiService.fetchUserInfo())
                    .catch(() => ({})))
                },
            },
        })


            return $scope.$watch('userContract', activate)
        },
    })
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/account/component/accountStatus.js